import React from 'react';
import { useDeviceSize } from '@vmos2/providers';
import styled from '@emotion/styled';

import { IconButton } from '../buttons';
import { Title } from '../titles/Title';
import { Header } from './Header';

type Props = {
  title: string,
  titleAriaHidden?: boolean,
  isDisabled?: boolean,
  onClick?: Function,
  notification?: Node | string,
  kioskAuth?: Node | string,
  hasShadow?: boolean,
  isFixed?: boolean,
  focusTitleOnMount?: boolean,
  buttonAriaLabel?: string,
};

export const BackButtonHeader = ({
  title,
  titleAriaHidden,
  isDisabled,
  onClick = () => window.history.back(),
  notification,
  hasShadow,
  isFixed,
  kioskAuth,
  focusTitleOnMount = false,
  buttonAriaLabel,
}: Props) => {
  const { isLarge } = useDeviceSize();

  return (
    <Header
      topNav={
        <BackButton>
          <BackBtn
            disabled={isDisabled}
            icon="ArrowLeft"
            onClick={onClick}
            data-test="header-back-btn"
            size={isLarge ? 'small' : 'xsmall'}
            mode="light"
            aria-label={buttonAriaLabel}
          />
          <Title
            ariaHidden={titleAriaHidden}
            level={isLarge ? 1 : 2}
            mode="BackButtonHeader"
            margin="none"
            mr={kioskAuth ? 8 : 0}
            noWrap
            autoFocus={focusTitleOnMount}
          >
            {title}
          </Title>
        </BackButton>
      }
      notification={notification}
      kioskAuth={kioskAuth}
      mode="Secondary"
      hasShadow={hasShadow}
      isFixed={isFixed}
    />
  );
};

const BackBtn = styled(IconButton)`
  margin-right: 16px;
`;

const BackButton = styled('div')`
  display: flex;
  align-items: center;
  margin-right: auto;
`;
